module.exports = __webpack_public_path__ + "static/media/Profile_9.a3d090e9.svg";